import { render, staticRenderFns } from "./Select-Customer-Person.vue?vue&type=template&id=072eea71&scoped=true"
import script from "./Select-Customer-Person.vue?vue&type=script&lang=js"
export * from "./Select-Customer-Person.vue?vue&type=script&lang=js"
import style0 from "./Select-Customer-Person.vue?vue&type=style&index=0&id=072eea71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072eea71",
  null
  
)

export default component.exports